import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useConcerns } from '../../contexts/ConcernContext';
import './ClientDashboard.css';

function ClientDashboard() {
  const navigate = useNavigate();
  const { concerns } = useConcerns();

  const handleLogout = () => {
    // Clear JWT token and user info
    localStorage.removeItem('token');
    localStorage.removeItem('user_info');
    localStorage.removeItem('selectedProject');
    navigate('/login');
  };

  const projectString = localStorage.getItem('selectedProject');
  const projectID = JSON.parse(projectString).projectID;

  // Updated to use new user_info structure
  const userInfoString = localStorage.getItem('user_info');
  const userInfo = JSON.parse(userInfoString);
  const userId = userInfo.user_id;

  const pendingCount = concerns.filter(c => c.status === 'Pending').length;

  return (
    <div className="dashboard">
      <nav className="dashboard-nav">
        <div className="container nav-content">
          <h2 className="logo">EngineeringCubes</h2>
          <button onClick={handleLogout} className="btn btn-secondary">
            Logout
          </button>
        </div>
      </nav>

      <div className="dashboard-content">
        <div className="container">
          <h1 className="dashboard-title">Client Dashboard</h1>
          <p className="dashboard-subtitle">Welcome back! Manage your project concerns here.</p>

          <div className="dashboard-grid">
            <div className="dashboard-card">
              <h3>Submit New Concern</h3>
              <p>Report any issues or concerns about your project</p>
              <button 
                onClick={() => navigate('/submit-concern')} 
                className="btn btn-primary"
              >
                Submit Concern
              </button>
            </div>

            <div className="dashboard-card">
              <h3>My Concerns</h3>
              <p>View and track all your submitted concerns</p>
              {concerns.length > 0 && (
                <div className="card-stat">
                  <span className="stat-number">{concerns.length}</span>
                  <span className="stat-label">Total Concerns</span>
                </div>
              )}
              <button 
                onClick={() => navigate('/my-concerns')} 
                className="btn btn-secondary"
              >
                View Concerns
              </button>
            </div>

            <div className="dashboard-card card-disabled">
              <h3>Project Status</h3>
              <p>Check the current status of your projects</p>
              <span className="coming-soon">Coming Soon</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientDashboard;